import React, {useEffect, useState, useContext} from 'react';

import { toast } from 'react-toastify';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

import api from '../api';

import useAuth from '../Context/hooks/useAuth';

import DescricaoPagina from '../components/DescricaoPagina';
import Card from '../components/Card';

import ActionComponent from '../api/ActionComponent';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


// const imgSprite = 'gridy';
 //const imgSprite = 'jdenticon';
// const imgSprite = 'identicon';
// const imgSprite = 'human';
const imgSprite = 'bottts';
//const imgSprite = 'initials';
//const imgSprite = 'avataaars';



class Produtos extends ActionComponent {
    constructor(props) {
        super(props)
        //this.state = { counter: 0 };

        
    }

    componentDidMount(){
        this.setState({
            apiUrl:'produtos'
        }, () => this.buscar());
    }

    remover = (id) => {
		api.delete('produtos/'+id)
			.then(res => {
               this.buscar();
			})
	}

    handleSubmit = event => {
		event.preventDefault();

		const formData = new FormData(event.target);

	    api.post('produtos', formData)
        .then(res => {
            event.target.reset();
            this.buscar();
            toast.success(<h6>Produto cadastrado</h6>)
        })
        .catch((error) => {
            console.log(error)
        });

	}

    renderForm(){
        return(
            <>
                <div className="container">
                    <div className="col-12 p-0">
                    

                            <form onSubmit={this.handleSubmit} style={{margin: '1rem'}}>
                                <div className="row">

                                    <div className="col-12 col-sm-3  my-2">
                                        <TextField size="small" label="Nome"  name="nome" variant="outlined" />
                                    </div>

                                    <div className="col-12 col-sm-3 my-2">
                                        <TextField size="small" label="Detalhes"  name="detalhes" variant="outlined" />
                                    </div>

                                    <div className="col-12 col-sm-3 my-2">
                                        <TextField type="number" size="small" label="Preco Sugerido"  name="precoSugerido" variant="outlined" />
                                    </div>

                                    <div className="col-12 col-sm-3 my-2">
                                        <TextField size="small" label="NCM"  name="ncm" variant="outlined" />
                                    </div>

                                    <div className="col-12 col-sm-3 my-2">
                                        <TextField size="small" label="Código de barras - EAN"  name="ean" variant="outlined" />
                                    </div>

                                    <div className="col-12 col-sm-3 my-2">
                                        <input type="file" name="imagem"/>
                                    </div>

                                    <div className="col-12 ">
                                        <Button type="submit" variant="contained" color="primary">Salvar</Button>
                                    </div>
                                </div>

                            </form>
                    </div>
                </div>

            </>
        )
    }



    render(){
        return(
            <>
            <DescricaoPagina titulo="Produtos" />
            <div className="container">
                <Card titulo="Cadastrar Produto">
                    {this.renderForm()}
                </Card>

              {/* <Card>
                    { this.state.data?.data && this.state.data?.data.map(produto => {
                        return(
                            <div className="my-3 mx-3" style={{display:"flex", alignItems:"center", position:"relative"}} key={produto.id}>
                                <div>
                                    <img width={70} src={
                                         produto?.imagem ? "http://192.168.1.66:4000/files/"+produto?.imagem :`https://avatars.dicebear.com/4.5/api/${imgSprite}/${produto.id}.svg`
                                        } ></img>
                                </div>
                                <div className="ml-2">
                                    <p className="m-0 p-0">{produto.nome}</p>
                                    <p className="m-0 p-0">{produto.detalhes}</p>
                                    <p className="m-0 p-0">{produto.precoSugerido}</p>
                                    <p className="m-0 p-0">{produto.criadoPor}</p>
                                    <IconButton style={{position: "absolute", right: 0, top:10}} onClick={() => this.remover(produto.id)} color="secondary">
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </div>
                        )
                    })}
              </Card> */}
                <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Produto</TableCell>
                            <TableCell align="right">Descrição</TableCell>
                            <TableCell align="right">Preço Sugerido</TableCell>
                            <TableCell align="right">EAN</TableCell>
                            <TableCell align="right">NCM</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        { this.state.data?.data && this.state.data?.data.map(produto => {
                            return(
                            <TableRow key={produto.id}>
                                <TableCell component="th" scope="row" align="center">
                                    <img width={70} src={
                                         produto?.imagem ? "http://192.168.1.66:4000/files/"+produto?.imagem :`https://avatars.dicebear.com/4.5/api/${imgSprite}/${produto.id}.svg`
                                        }>
                                    </img>
                                </TableCell>
                                <TableCell component="th" scope="row"> {produto.nome}</TableCell>
                                <TableCell align="right">{produto.detalhes}</TableCell>
                                <TableCell align="right">R$ {produto.precoSugerido}</TableCell>
                                <TableCell align="right">{produto.ean}</TableCell>
                                <TableCell align="right">{produto.ncm}</TableCell>
                                <TableCell align="right">
                                    <IconButton onClick={() => this.remover(produto.id)} color="secondary">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                            )
                        })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Paper className="text-center  my-2">
                    {this.renderPaginacao()}
                </Paper>

            </div>

                
        </>
        )
    }
}

export default Produtos;